<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="Schedule">
    <app-survey-schedular [survey]="survey"></app-survey-schedular>
  </mat-tab>
</mat-tab-group>
